<div class="flex flex-col gap-4">
    <div class="flex">
        <div class="flex gap-1 items-center">
            <label class="font-semibold">Audience</label>
         
                <p-select [options]="audienceOptions()" appendTo="body" [(ngModel)]="selectedAudience"
                (onChange)="selectedAudienceChange($event)" [disabled]="loadingAudience()"></p-select>
                @if(loadingAudience()) {
                <p-progress-spinner styleClass="w-4 h-4"></p-progress-spinner>
                }
         
            
        </div>


    </div>

    <div class="flex flex-col gap-4">
        <div class="flex flex-col">
            <textarea #messageInput="ngModel" pTextarea appInputRestriction="sms" [minlength]="10"
                [maxlength]="153" required [(ngModel)]="textMessage" rows="5"></textarea>
            Sms messages are limited to 153 characters and can only include letters, numbers, and the following
            symbols: ! .
            ?! $ + * : ; &lt; &gt; " ' / # % _ =
            ( )
        </div>
        <div>

            @if(messageInput.hasError("maxlength")) {
            <div class="text-error">Your message must be 153 characters or less</div>
            }

            @if(messageInput.hasError("required")) {
            <div class="text-error">Message is required</div>
            }

            @if(messageInput.hasError("minlength")) {
            <div class="text-error">Your message must be at lest 10 characters</div>
            }
        </div>

        <div class="flex gap-2">

            <app-save-button
                [disabled]="messageInput.hasError('maxlength') || messageInput.hasError('minlength') || messageInput.hasError('required') || loadingAudience()"
                (saveClick)="sendMessage()" label="Send"></app-save-button>
            <div>This message will be sent to {{audience()?.length}} people</div>
            @if(loadingAudience()) {
                <p-progress-spinner styleClass="w-4 h-4"></p-progress-spinner>
                }
        </div>
    </div>
</div>